import React, {useState} from 'react';
import {Heart} from '../../../components';
import styles from './LikeButton.module.scss';

interface Props {
  liked: boolean;
  onToggleLike(liked: boolean): void;
}
export function LikeButton({liked, onToggleLike}: Props) {
  const [isLiked, setLiked] = useState(liked);

  const toggleLike = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    onToggleLike(isLiked);
    setLiked(!isLiked);
  };

  return (
    <button className={styles.LikeButton} onClick={toggleLike}>
      <Heart liked={isLiked} />
    </button>
  );
}
